document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll(".slider");

  sliders.forEach((slider) => {
    const items = slider.querySelector(".slider__items > *");
    const prevButton = slider.querySelector(".slider__prev");
    const nextButton = slider.querySelector(".slider__next");

    if (!items) {
      return;
    }

    // Slide forward/backward.
    const slideForward = () => {
      // Recalculate cardWidth in case of window resize.
      const cardWidth = slider.querySelector(".slider__items > *").offsetWidth;
      slider.scrollBy(window.innerWidth - 2 * cardWidth, 0);
    };

    const slideBackward = () => {
      // Recalculate cardWidth in case of window resize.
      const cardWidth = slider.querySelector(".slider__items > *").offsetWidth;
      slider.scrollBy(-window.innerWidth + 2 * cardWidth, 0);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target.className.includes("start")) {
            slider.classList.toggle("slider_start", entry.isIntersecting);
          }
          if (entry.target.className.includes("end")) {
            slider.classList.toggle("slider_end", entry.isIntersecting);
          }
        });
      },
      {
        root: slider,
      }
    );

    prevButton?.addEventListener("click", slideBackward);
    nextButton?.addEventListener("click", slideForward);

    const observed = slider.querySelectorAll(
      ".slider__start-gutter, .slider__end-gutter"
    );
    observed.forEach((el) => observer.observe(el));
  });
});
